import { reactive } from 'vue';
import callApi from '@/utils/callApi';

let categories = reactive([]);
let lootCrateStatus = reactive([]);

async function loadTokenShop () {
  try {
    const res = await callApi('get', '/v1/client/token-shop');

    if (res.status !== 200) {
      return false;
    }
    
    const json = await res.json();
    if (json.error) {
      return false;
    }

    Object.assign(categories, json.categories);

    const lootCrateMap = {};
    for (const lootCrate of json?.customerLootCratesStatus || []) {
      lootCrateMap[lootCrate.typeName] = lootCrate;
    }
    Object.assign(lootCrateStatus, lootCrateMap);
  } catch (e) {
    return false;
  }

  return true;
}

export {
  categories,
  lootCrateStatus,
  loadTokenShop,
};
